import React from 'react';
import ReactDOM, { Root } from 'react-dom/client';
import App from './App';

import { store } from './store/store';
import { Provider } from 'react-redux';

import * as serviceWorker from './serviceWorker';

import 'scss/index.scss';

import { APIProvider } from '@vis.gl/react-google-maps';
import LoginVerification from 'components/Auth/LoginVerification';
import { HelmetProvider } from 'react-helmet-async';

const root: Root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <APIProvider
        apiKey={window.runtimeConfig.REACT_APP_GOOGLE_KEY}
        libraries={['places', 'marker', 'routes']}
      >
        <HelmetProvider>
          <LoginVerification>
            <App />
          </LoginVerification>
        </HelmetProvider>
      </APIProvider>
    </Provider>
  </React.StrictMode>,
);

serviceWorker.unregister();
